module.exports = __webpack_public_path__ + "assets/1e1fc1df8e5370bf355403378e18f317.mp3";